export const sort = (
  a: string | number | boolean | undefined,
  b: string | number | boolean | undefined,
  undefinedFirst?: boolean
): number => {
  if (a === undefined && b !== undefined) return undefinedFirst ? -1 : 1;
  if (b === undefined && a !== undefined) return undefinedFirst ? 1 : -1;
  if (a === undefined && b === undefined) return 0;
  return a === b ? 0 : a! > b! ? 1 : -1;
};
